import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "controller-wrapper d-flex" };
const _hoisted_2 = { class: "brg-input-section multi-date-picker-activator" };
const _hoisted_3 = { class: "brg-color-grey-600 text-subtitle-2" };
import { computed, ref, } from 'vue';
import { i18n } from '@/locales';
import dateFormatType from '@/constants/dateFormatType';
import { format } from 'date-fns';
import { makeRangePickerDate } from '@/utils';
import { afterDays, beforeDays, } from '@/utils/time';
import vuexStore from '@/vuex-store';
const lc = 'views.worker.worker_profit_detail_dialog.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'WorkerProfitDetailDialogController',
    setup(__props) {
        const locale = {
            selectPeriod: i18n.t(`${lc}select_period`),
        };
        // 조회 기간 시작일
        const fromDate = computed(() => vuexStore.state.workerProfitDetailDialog.filterOption.fromDate);
        // 조회 기간 종료일
        const toDate = computed(() => vuexStore.state.workerProfitDetailDialog.filterOption.toDate);
        // 조회 기간
        const selectedPeriod = computed({
            get() {
                return [
                    fromDate.value,
                    toDate.value,
                ];
            },
            set() { },
        });
        const formattedPeriod = computed(() => selectedPeriod.value.join(' ~ '));
        /**
             * 조회 기간 변경 핸들러
             */
        const handleChangeDatePicker = (value) => {
            const range = makeRangePickerDate(value, dateFormatType.DATE);
            // @ts-ignore
            vuexStore.dispatch('workerProfitDetailDialog/setFilterOption', {
                fromDate: range[0],
                toDate: range[1],
            });
        };
        const today = ref(new Date());
        const selectedDateFormat = dateFormatType.DATE;
        // 최소 선택 가능일
        const minDate = ref('');
        // 최대 선택 가능일
        const maxDate = ref(format(today.value, selectedDateFormat));
        const resetMinMaxDate = () => {
            minDate.value = '';
            maxDate.value = format(today.value, selectedDateFormat);
        };
        /**
             * 조회기간 범위 시작 핸들러
             * @param startDate
             */
        const handleStartRangeDatePicker = (startDate) => {
            const dateFormatStartDate = new Date(startDate);
            minDate.value = format(beforeDays(dateFormatStartDate, 30), selectedDateFormat);
            const isMaxLaterThanToday = afterDays(dateFormatStartDate, 30) > today.value.getTime();
            // 처음 선택한 날로부터 계산된 31일 초과된 날이 오늘보다 이후일 경우 오늘날짜로 비활성화
            if (isMaxLaterThanToday) {
                maxDate.value = format(afterDays(today.value, 0), selectedDateFormat);
                return;
            }
            maxDate.value = format(afterDays(dateFormatStartDate, 30), selectedDateFormat);
        };
        /**
             * 조회기간 범위 종료 핸들러
             */
        const handleEndRangeDatePicker = () => {
            resetMinMaxDate();
        };
        return (_ctx, _cache) => {
            const _component_vue_datepicker_action_row = _resolveComponent("vue-datepicker-action-row");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_vue_datepicker = _resolveComponent("vue-datepicker");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createCommentVNode(" 조회 기간 "),
                _createVNode(_component_vue_datepicker, {
                    modelValue: selectedPeriod.value,
                    "onUpdate:modelValue": [
                        _cache[0] || (_cache[0] = ($event) => ((selectedPeriod).value = $event)),
                        handleChangeDatePicker
                    ],
                    range: "",
                    position: "left",
                    format: _unref(selectedDateFormat),
                    "model-type": _unref(selectedDateFormat),
                    "min-date": minDate.value,
                    "max-date": maxDate.value,
                    onRangeStart: handleStartRangeDatePicker,
                    onRangeEnd: handleEndRangeDatePicker
                }, {
                    "action-row": _withCtx((props) => [
                        _createVNode(_component_vue_datepicker_action_row, _normalizeProps(_guardReactiveProps(props)), null, 16 /* FULL_PROPS */)
                    ]),
                    "dp-input": _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("span", _hoisted_3, _toDisplayString(locale.selectPeriod), 1 /* TEXT */),
                            _createVNode(_component_v_text_field, {
                                value: formattedPeriod.value,
                                variant: "outlined",
                                density: "compact",
                                readonly: "",
                                "hide-details": "",
                                class: "mt-2",
                                "bg-color": "white",
                                "prepend-inner-icon": "mdi-calendar-month-outline"
                            }, null, 8 /* PROPS */, ["value"])
                        ])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "format", "model-type", "min-date", "max-date"])
            ]));
        };
    }
});
